module.exports = __webpack_public_path__ + "static/media/sad-trombone.66d8e74c.mp3";